export default {
  // Header
  "nav.home": "الرئيسية",
  "nav.about": "من نحن",
  "nav.services": "خدماتنا",
  "nav.consultation": "طلب استشارة",
  "nav.contact": "تواصل معنا",
  
  // Hero Section
  "hero.title": "نساعدك على الإقلاع بأمان",
  "hero.subtitle": "بخدمات طبية مجانية ومعتمدة من جمعية مكافحة التدخين بالأفلاج",
  "hero.cta.consultation": "ابدأ طلب استشارة",
  "hero.cta.services": "تعرف على خدماتنا",
  
  // About Section
  "about.title": "عن الجمعية",
  "about.vision.title": "رؤيتنا",
  "about.vision.text": "مجتمع خالٍ من التدخين يتمتع بصحة أفضل وحياة أطول",
  "about.mission.title": "رسالتنا",
  "about.mission.text": "تقديم خدمات طبية متخصصة ومجانية لمساعدة المدخنين على الإقلاع عن التدخين من خلال برامج علاجية وتوعوية شاملة",
  
  // Services
  "services.title": "خدماتنا",
  "services.awareness.title": "التوعية",
  "services.awareness.desc": "برامج توعوية شاملة عن أضرار التدخين وفوائد الإقلاع",
  "services.consultation.title": "الاستشارات",
  "services.consultation.desc": "استشارات طبية متخصصة مع أطباء معتمدين",
  "services.medical.title": "الدعم الطبي",
  "services.medical.desc": "علاج طبي متكامل وأدوية مساعدة على الإقلاع",
  "services.followup.title": "المتابعة",
  "services.followup.desc": "متابعة دورية ومستمرة لضمان نجاح رحلة الإقلاع",
  
  // Features
  "features.title": "لماذا عيادة الإقلاع؟",
  "features.privacy.title": "خصوصية عالية",
  "features.privacy.desc": "نحافظ على سرية معلوماتك الطبية بأعلى معايير الأمان",
  "features.doctors.title": "أطباء معتمدون",
  "features.doctors.desc": "فريق طبي متخصص ومعتمد في علاج الإدمان",
  "features.followup.title": "متابعة مستمرة",
  "features.followup.desc": "نتابع معك خطوة بخطوة حتى تحقيق الهدف",
  "features.whatsapp.title": "دعم عبر الواتساب",
  "features.whatsapp.desc": "تواصل سريع ومباشر مع الفريق الطبي",
  
  // How it works
  "howitworks.title": "كيف نعمل؟",
  "howitworks.step1": "إرسال الطلب",
  "howitworks.step1.desc": "املأ نموذج طلب الاستشارة",
  "howitworks.step2": "مراجعة الطبيب",
  "howitworks.step2.desc": "يراجع الطبيب حالتك الصحية",
  "howitworks.step3": "تحديد الموعد",
  "howitworks.step3.desc": "اختر الموعد المناسب لك",
  "howitworks.step4": "التواصل عبر الشات",
  "howitworks.step4.desc": "تحدث مع الطبيب مباشرة",
  "howitworks.step5": "تلقي العلاج والمتابعة",
  "howitworks.step5.desc": "ابدأ رحلة الإقلاع بثقة",
  
  // Testimonials
  "testimonials.title": "آراء المرضى",
  
  // Footer
  "footer.contact": "تواصل معنا",
  "footer.phone": "الهاتف",
  "footer.email": "البريد الإلكتروني",
  "footer.address": "العنوان",
  "footer.address.text": "الأفلاج، المملكة العربية السعودية",
  "footer.sitemap": "خريطة الموقع",
  "footer.social": "تابعنا",
  "footer.rights": "جميع الحقوق محفوظة © 2024 عيادة الإقلاع",
  
  // Common
  "button.learnmore": "اعرف المزيد",
  "button.requestnow": "اطلب الخدمة الآن",
  "button.send": "إرسال",
  "button.confirm": "تأكيد",
  "button.back": "رجوع",
  "button.next": "التالي",
  
  // Contact
  "contact.title": "تواصل معنا",
  "contact.subtitle": "نحن هنا لمساعدتك في أي وقت",
  "contact.name": "الاسم",
  "contact.phone": "رقم الجوال",
  "contact.message": "الرسالة",
  "contact.success": "تم إرسال رسالتك بنجاح",
  
  // Consultation Form
  "consultation.title": "طلب استشارة طبية",
  "consultation.subtitle": "املأ البيانات التالية وسيتواصل معك الفريق الطبي قريباً",
  "consultation.fullname": "الاسم الكامل",
  "consultation.city": "المدينة",
  "consultation.mobile": "رقم الجوال",
  "consultation.whatsapp": "رقم الواتساب",
  "consultation.gender": "الجنس",
  "consultation.gender.male": "ذكر",
  "consultation.gender.female": "أنثى",
  "consultation.location": "الموقع",
  "consultation.medical.history": "التاريخ المرضي",
  "consultation.current.medications": "الأدوية الحالية",
  "consultation.notes": "ملاحظات إضافية",
  "consultation.submit": "إرسال الطلب",
  "consultation.success.title": "تم استلام طلبك بنجاح",
  "consultation.success.message": "طلبك قيد المراجعة من قبل الفريق الطبي وسيتم التواصل معك قريباً",
  
  // Appointment
  "appointment.title": "اختيار الموعد",
  "appointment.select.date": "اختر التاريخ",
  "appointment.select.time": "اختر الوقت",
  "appointment.confirm": "تأكيد الموعد",
  "appointment.success": "تم تأكيد موعدك بنجاح",
  
  // Chat
  "chat.title": "المحادثة مع الطبيب",
  "chat.type.message": "اكتب رسالتك...",
  "chat.send": "إرسال",
  "chat.attach": "إرفاق ملف",
  
  // Notifications
  "notifications.title": "الإشعارات",
  "notifications.empty": "لا توجد إشعارات جديدة",
  
  // About Page
  "aboutpage.title": "من نحن",
  "aboutpage.story.title": "قصتنا",
  "aboutpage.story.text": "جمعية خيرية متخصصة في مكافحة التدخين بالأفلاج، تأسست بهدف مساعدة المدخنين على الإقلاع عن التدخين من خلال تقديم خدمات طبية وتوعوية مجانية ومتخصصة",
  "aboutpage.achievements.title": "إنجازاتنا",
  "aboutpage.patients": "مريض",
  "aboutpage.success": "نسبة النجاح",
  "aboutpage.years": "سنوات خبرة",
  "aboutpage.sessions": "جلسة علاجية",
  
  // Services Page
  "servicespage.title": "خدماتنا الطبية",
  "servicespage.quit.title": "خدمة الإقلاع عن التدخين",
  "servicespage.quit.desc": "برنامج متكامل للإقلاع عن التدخين يشمل العلاج الدوائي والسلوكي",
  "servicespage.consultation.title": "الاستشارات الطبية",
  "servicespage.consultation.desc": "استشارات طبية متخصصة مع أطباء معتمدين في علاج الإدمان",
  "servicespage.followup.title": "المتابعة الدورية",
  "servicespage.followup.desc": "متابعة مستمرة لحالتك الصحية وتقدمك في رحلة الإقلاع",
  "servicespage.behavioral.title": "العلاج السلوكي",
  "servicespage.behavioral.desc": "جلسات علاج سلوكي معرفي لتغيير العادات المرتبطة بالتدخين",
  "servicespage.psychological.title": "الدعم النفسي",
  "servicespage.psychological.desc": "دعم نفسي متخصص للتعامل مع التحديات النفسية أثناء الإقلاع"
};